import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default function RehabNotificationsViewAll() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('https://physiodirectory.in/api/rehab-notifications')
      .then(res => setNotifications(res.data.notifications || []))
      .catch(() => setNotifications([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="container-fluid px-3 pb-5 pt-3">
      <h2 className="section-title mb-0">All Notifications</h2>
      <div className="mt-3">
        {loading ? (
          <div className="text-center py-3">Loading...</div>
        ) : notifications.length === 0 ? (
          <h4 className="fw-semibold text-muted mb-2">No notifications found</h4>
        ) : (
          <div className="row g-3">
            {notifications.map(n => (
              <div className="col-12 col-md-6" key={n.id}>
                <div className="card h-100 p-3">
                  <div className="d-flex align-items-center mb-2">
                    <img src={n.image || '/assets/notification-default.png'} alt="Notification" style={{width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', marginRight: 12}} />
                    <div>
                      <h6 className="fw-bold mb-1" style={{ fontSize: '1rem', color: '#2d3748' }}>{n.title}</h6>
                      <span className="badge bg-primary-subtle text-primary px-2 py-1 small mb-1">Notification</span>
                      <div className="text-muted small">{n.date}</div>
                    </div>
                  </div>
                  <div className="mb-2 text-truncate">{n.description}</div>
                  <Link to={`/rehab-notifications/${n.id}`} className="btn btn-outline-primary btn-sm w-100 rounded-pill fw-semibold mt-auto">View Details</Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
